import { HttpError } from 'src/http/errors/http-error';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { Either } from 'src/utils/either';

import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  HttpTypes,
  InternalServerError,
  TooManyRequestsError,
  UnexpectedError,
} from '../../http';

export class StoresRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getStores(
    params?: any
  ): Promise<
    Either<
      BadRequestError | UnexpectedError | InternalServerError | AccessDeniedError | ConnectionError | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `stores/all-stores-admin`,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async createStore(
    body?: any
  ): Promise<
    Either<
      BadRequestError | UnexpectedError | InternalServerError | AccessDeniedError | ConnectionError | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `stores`,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updateStore(
    id: string,
    body?: any
  ): Promise<
    Either<
      BadRequestError | UnexpectedError | InternalServerError | AccessDeniedError | ConnectionError | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `stores/${id}`,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async changeStatus(
    id: string
  ): Promise<
    Either<
      BadRequestError | UnexpectedError | InternalServerError | AccessDeniedError | ConnectionError | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `stores/change-status/${id}`,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async deleteStore(
    id: string
  ): Promise<
    Either<
      BadRequestError | UnexpectedError | InternalServerError | AccessDeniedError | ConnectionError | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'delete',
      url: `stores/${id}`,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async uploadImage(body?: any): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `media/upload/base64/stores`,
      body,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }
}
